export function parseHttpUrlOrNull(value) {
  try {
    const raw = String(value || "").trim();
    if (!raw) return null;
    const url = new URL(raw, window.location.origin);
    if (url.protocol !== "http:" && url.protocol !== "https:") return null;
    return url;
  } catch {
    return null;
  }
}

export function cacheOriginalHostnameMarker() {
  const encodedHost = encodeURIComponent(window.location.host);
  const base = `original_hostname=${encodedHost}; path=/; max-age=300`;
  document.cookie = base;
  document.cookie = `${base}; domain=localhost`;
  document.cookie = `${base}; domain=.localhost`;
}

/** Consumer exchanges code via POST /api/v1/auth/token_from_code to get the token. */
export function buildReturnUrlWithCode(returnUrl, payload) {
  const base = parseHttpUrlOrNull(returnUrl);
  if (!base) return null;
  const code = payload?.code;
  if (!code) return null;
  base.searchParams.set("code", code);
  if (typeof payload?.expires_in === "number") base.searchParams.set("expires_in", String(payload.expires_in));
  return base.toString();
}
